/** The currency every amount on the screens is written in: the one the signed-in
 *  user's company is set to, as its settings name it. */
export interface CompanyCurrency {
    name: string;
    symbol: string;
    position?: "before" | "after";
    digits?: number;
}

/** the Saudi riyal sign, drawn by the bundled riyal face until system fonts carry it */
const RIYAL_SIGN = "⃁";

let current: CompanyCurrency | null = null;

export function setCompanyCurrency(currency: CompanyCurrency | null | undefined) {
    current = currency ?? null;
}

/** The sign written after an amount; the riyal takes its new sign. */
export function currencySymbol(): string {
    if (!current) {
        return "";
    }
    if (current.name === "SAR") {
        return RIYAL_SIGN;
    }
    return current.symbol || current.name || "";
}

/** An amount already formatted, followed directly by the company's currency sign. */
export function withCurrency(text: string): string {
    const symbol = currencySymbol();
    return text && symbol ? `${text} ${symbol}` : text;
}
